(function () {
  'use strict';
  const rootElement = document.getElementById('order-settings');
  if (!rootElement || !window.TLGGCore) return;
  const config = JSON.parse(rootElement.textContent);
  const core = window.TLGGCore;
  const text = config.text;
  const money = value => new Intl.NumberFormat(config.locale || 'en-US', { style: 'currency', currency: config.currency }).format(value / 100);
  const products = new Map();
  const previewMode = config.previewMode === true;
  let previewCart = null;
  if (previewMode && window.TLGGPreviewCart && Array.isArray(window.TLGG_PREVIEW_CATALOG)) {
    let storage;
    try { storage = window.sessionStorage; } catch { /* Storage can be unavailable in private browsing. */ }
    previewCart = window.TLGGPreviewCart.create(window.TLGG_PREVIEW_CATALOG, storage, config.previewKey, text.previewError);
    window.TLGG_PREVIEW_CATALOG.forEach(product => products.set(product.handle, product));
  }
  let cart = null;
  let changing = false;
  let selectedProduct = null;
  let selectedConfig = null;
  let activeTrigger = null;
  let toastTimeout;
  const customDialog = document.getElementById('customization-dialog');
  const customForm = document.getElementById('customization-form');
  const cartDialog = document.getElementById('cart-dialog');
  const checkoutForm = document.getElementById('pickup-checkout');
  const dateSelect = document.getElementById('pickup-date');
  const timeSelect = document.getElementById('pickup-time');

  function discover() {
    if (previewMode) return;
    document.querySelectorAll('script[data-product]').forEach(node => {
      try { products.set(node.dataset.product, JSON.parse(node.textContent)); } catch { node.closest('article')?.querySelector('[data-customize]')?.removeAttribute('data-customize'); }
    });
  }
  discover();
  document.addEventListener('shopify:section:load', discover);
  function element(tag, content, className) {
    const node = document.createElement(tag);
    if (content !== undefined && content !== null) node.textContent = content;
    if (className) node.className = className;
    return node;
  }
  function toast(message) {
    const status = document.getElementById('order-status');
    status.textContent = message;
    clearTimeout(toastTimeout);
    toastTimeout = setTimeout(() => { status.textContent = ''; }, 4500);
  }
  async function request(endpoint, body) {
    if (previewMode) {
      if (!previewCart) throw new Error(text.previewError);
      return previewCart.request(endpoint, body);
    }
    const response = await fetch(config.root + endpoint, { method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) }, ...(body ? { body: JSON.stringify(body) } : {}) });
    const data = await response.json();
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : text.networkError);
    return data;
  }
  function cartError(message) { document.querySelectorAll('[data-cart-error]').forEach(n => { n.textContent = message; }); }
  function setBusy(value) {
    changing = value;
    document.querySelectorAll('[data-change-quantity]').forEach(button => { button.disabled = value; });
    if (customForm) customForm.querySelector('[type=submit]').disabled = value || !currentVariant()?.available;
    updateCheckoutState();
  }
  async function refreshCart() {
    cart = await request('cart.js');
    renderCart();
    return cart;
  }
  function renderCart() {
    if (!cart) return;
    document.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = cart.item_count; });
    document.querySelectorAll('[data-cart-total]').forEach(node => { node.textContent = money(cart.total_price); });
    document.querySelectorAll('[data-cart-lines]').forEach(container => {
      const content = document.createDocumentFragment();
      if (!cart.items.length) {
        const empty = element('div', null, 'empty-cart');
        empty.append(element('h3', text.empty), element('p', text.emptyHelp));
        const link = element('a', text.browse, 'button button-pink');
        link.href = config.root + 'collections/menu';
        empty.append(link);
        content.append(empty);
      }
      cart.items.forEach(item => {
        const row = element('article', null, 'cart-line');
        const details = element('div');
        details.append(element('h3', item.product_title));
        if (item.variant_title && item.variant_title !== 'Default Title') details.append(element('p', item.variant_title));
        Object.entries(item.properties || {}).forEach(([key, value]) => { if (!key.startsWith('_') && value) details.append(element('p', `${key}: ${value}`)); });
        details.append(element('p', `${money(item.final_price)} ${text.each.toLowerCase()}`));
        const remove = element('button', text.remove, 'line-remove');
        remove.type = 'button'; remove.dataset.changeQuantity = item.key; remove.dataset.quantity = '0'; remove.setAttribute('aria-label', `${text.remove} ${item.product_title}`);
        details.append(remove);
        const controls = element('div', null, 'quantity-control');
        [-1, 1].forEach((direction, index) => {
          const button = element('button', direction < 0 ? '−' : '+');
          button.type = 'button'; button.dataset.changeQuantity = item.key; button.dataset.quantity = String(item.quantity + direction);
          button.setAttribute('aria-label', `${text.quantity} ${item.product_title} ${direction < 0 ? '−1' : '+1'}`);
          controls.append(button);
          if (index === 0) controls.append(element('b', String(item.quantity)));
        });
        row.append(details, controls, element('strong', money(item.final_line_price)));
        content.append(row);
      });
      container.replaceChildren(content);
    });
    document.querySelectorAll('.cart-review').forEach(node => { node.hidden = !cart.items.length; });
    if (checkoutForm) checkoutForm.hidden = !cart.items.length;
    updateCheckoutState();
  }
  function selectedOptions() {
    if (!selectedProduct) return {};
    const data = new FormData(customForm);
    const values = {};
    core.optionNames(selectedProduct).forEach((name, index) => {
      values[name] = name === 'Extras' ? core.extraValue(selectedConfig.extras || [], data.getAll('extras')) : data.get(`option-${index}`) || selectedProduct.variants[0].options[index];
    });
    return values;
  }
  function currentVariant() { return selectedProduct ? core.variantFor(selectedProduct, selectedOptions()) : null; }
  function updatePrice() {
    const variant = currentVariant();
    const button = customForm.querySelector('[type=submit]');
    const quantity = Number(customForm.elements.quantity.value) || 1;
    button.disabled = changing || !variant?.available;
    button.textContent = variant?.available ? `${text.add} · ${money(variant.price * quantity)}` : text.unavailable;
    if (variant) customForm.querySelectorAll('input[name="extras"]').forEach(input => {
      const chosen = new FormData(customForm).getAll('extras');
      const alternative = input.checked ? chosen.filter(v => v !== input.value) : [...chosen, input.value];
      const other = core.variantFor(selectedProduct, { ...selectedOptions(), Extras: core.extraValue(selectedConfig.extras, alternative) });
      const fee = other ? (input.checked ? variant.price - other.price : other.price - variant.price) : null;
      let priceLabel = input.parentElement.querySelector('b');
      if (!priceLabel) { priceLabel = element('b'); input.parentElement.querySelector('span').append(priceLabel); }
      priceLabel.textContent = fee !== null && fee > 0 ? ` +${money(fee)}` : '';
    });
  }
  function choiceGroup(name, title, choices, kind = 'radio', checked = null) {
    const fieldset = element('fieldset', null, 'modifier-group');
    const legend = element('legend', title + ' ');
    legend.append(element('small', kind === 'radio' ? text.chooseOne : text.selectAny));
    const group = element('div', null, 'modifier-options');
    choices.forEach((value, index) => {
      const label = element('label', null, 'modifier-choice');
      const input = element('input'); input.type = kind; input.name = name; input.value = value;
      input.checked = checked ? checked.includes(value) : kind === 'radio' && index === 0;
      label.append(input, element('span', value)); group.append(label);
    });
    fieldset.append(legend, group);
    return fieldset;
  }
  function openCustomization(handle, trigger) {
    if (changing || !products.has(handle)) return;
    selectedProduct = products.get(handle);
    selectedConfig = window.TLGG_MENU_CONFIG[handle] || { spice: false, removals: [], extras: [] };
    customForm.reset();
    document.getElementById('customization-error').textContent = '';
    document.getElementById('customization-title').textContent = selectedProduct.title;
    const description = new DOMParser().parseFromString(selectedProduct.description || '', 'text/html').body.textContent;
    document.getElementById('customization-description').textContent = description;
    const content = document.createDocumentFragment();
    core.optionNames(selectedProduct).forEach((name, index) => {
      if (name === 'Title' && selectedProduct.variants.length === 1 && selectedProduct.variants[0].options[index] === 'Default Title') return;
      if (name === 'Extras' && selectedConfig.extras.length) {
        content.append(choiceGroup('extras', text.extras, selectedConfig.extras, 'checkbox'));
      } else {
        content.append(choiceGroup(`option-${index}`, name, [...new Set(selectedProduct.variants.map(v => v.options[index]))]));
      }
    });
    if (selectedConfig.spice) content.append(choiceGroup('spice', text.spice, ['1', '2', '3', '4', '5']));
    if (selectedConfig.removals.length) content.append(choiceGroup('removals', text.removals, selectedConfig.removals, 'checkbox'));
    document.getElementById('customization-options').replaceChildren(content);
    activeTrigger = trigger;
    updatePrice();
    customDialog.showModal();
  }
  document.querySelectorAll('dialog').forEach(dialog => {
    dialog.addEventListener('click', event => { if (event.target.closest('[data-close-dialog]')) dialog.close(); });
    dialog.addEventListener('close', () => { if (activeTrigger?.isConnected) activeTrigger.focus(); });
  });
  document.addEventListener('click', async event => {
    const customize = event.target.closest('[data-customize]');
    if (customize && products.has(customize.dataset.customize)) { event.preventDefault(); openCustomization(customize.dataset.customize, customize); return; }
    const openCart = event.target.closest('[data-open-cart]');
    if (openCart) {
      event.preventDefault(); activeTrigger = openCart;
      try { await refreshCart(); cartError(''); cartDialog.showModal(); } catch (error) { cartError(error.message); window.location.assign(config.cartUrl); }
      return;
    }
    const change = event.target.closest('[data-change-quantity]');
    if (change && !changing) {
      setBusy(true); cartError('');
      try {
        await request('cart/change.js', { id: change.dataset.changeQuantity, quantity: Number(change.dataset.quantity) });
        await refreshCart(); toast(text.updated);
      } catch (error) {
        cartError(error.message);
        try { await refreshCart(); } catch { cartError(text.networkError); }
      } finally { setBusy(false); }
    }
  });
  customForm.addEventListener('change', updatePrice);
  customForm.addEventListener('input', updatePrice);
  customForm.addEventListener('submit', async event => {
    event.preventDefault();
    if (changing) return;
    const variant = currentVariant();
    const formData = new FormData(customForm);
    const quantity = Number(formData.get('quantity'));
    if (!variant?.available || !Number.isInteger(quantity) || quantity < 1 || quantity > 99) return;
    const properties = core.properties(selectedConfig, { spice: formData.get('spice'), removals: formData.getAll('removals'), instructions: formData.get('instructions') });
    const errorNode = document.getElementById('customization-error'); errorNode.textContent = '';
    setBusy(true);
    try {
      await request('cart/add.js', { items: [{ id: variant.id, quantity, properties }] });
      customDialog.close();
      await refreshCart(); toast(text.added); cartError(''); cartDialog.showModal();
    } catch (error) {
      errorNode.textContent = error.message; cartError(error.message);
      try { await refreshCart(); } catch { cartError(text.networkError); }
    } finally { setBusy(false); updatePrice(); }
  });
  function fillOptions(select, placeholder, values, selected) {
    const fragment = document.createDocumentFragment(); fragment.append(new Option(placeholder, ''));
    values.forEach(item => fragment.append(new Option(item.label, item.value, false, item.value === selected)));
    select.replaceChildren(fragment);
  }
  function updateDates(restore = false) {
    if (!dateSelect) return;
    const date = restore ? dateSelect.dataset.selected : dateSelect.value;
    const time = restore ? timeSelect.dataset.selected : timeSelect.value;
    fillOptions(dateSelect, text.chooseDate, core.dates(new Date(), config), date);
    fillOptions(timeSelect, text.chooseTime, dateSelect.value ? core.slots(config) : [], time);
    timeSelect.disabled = !dateSelect.value;
    updateCheckoutState();
  }
  function updateCheckoutState() {
    if (!checkoutForm) return;
    const button = checkoutForm.querySelector('[data-checkout]');
    if (button) button.disabled = previewMode || !config.checkoutEnabled || changing || !cart?.items.length || !core.validPickup(dateSelect.value, timeSelect.value, new Date(), config);
  }
  let nativeCheckout = false;
  if (checkoutForm) {
    updateDates(true);
    dateSelect.addEventListener('change', () => { timeSelect.value = ''; updateDates(); });
    timeSelect.addEventListener('change', updateCheckoutState);
    checkoutForm.addEventListener('submit', async event => {
      if (previewMode) { event.preventDefault(); return; }
      if (nativeCheckout) { nativeCheckout = false; return; }
      event.preventDefault();
      if (!config.checkoutEnabled || changing) return;
      const errorNode = checkoutForm.querySelector('[data-checkout-error'); errorNode.textContent = '';
      const date = dateSelect.value; const time = timeSelect.value;
      if (!core.validPickup(date, time, new Date(), config)) { updateDates(); errorNode.textContent = text.choosePickup; return; }
      setBusy(true);
      try {
        await refreshCart();
        if (!cart.items.length) return;
        if (!core.validPickup(date, time, new Date(), config)) throw new Error(text.stale);
        const approvalEvent = new CustomEvent('tlgg:before-checkout', { cancelable: true, detail: { cart, date, time, timeZone: config.timeZone } });
        if (!checkoutForm.dispatchEvent(approvalEvent)) return;
        const attributes = { ...cart.attributes, 'Pickup date': date, 'Pickup time': time, 'Pickup timezone': config.timeZone };
        const note = checkoutForm.elements.note.value.trim();
        cart = await request('cart/update.js', { attributes, note });
        if (cart.attributes?.['Pickup date'] !== date || cart.attributes?.['Pickup time'] !== time) throw new Error(text.networkError);
        if (!core.validPickup(date, time, new Date(), config)) throw new Error(text.stale);
        toast(text.processing);
        nativeCheckout = true;
        const button = checkoutForm.querySelector('[data-checkout]'); button.disabled = false;
        checkoutForm.requestSubmit(button);
      } catch (error) { errorNode.textContent = error.message; }
      finally { setBusy(false); }
    });
  }
  document.querySelectorAll('[data-event-date]').forEach(input => {
    const date = new Date(core.today(new Date(), config) + 'T12:00:00Z'); date.setUTCDate(date.getUTCDate() + config.leadDays); input.min = date.toISOString().slice(0, 10);
  });
  window.addEventListener('pageshow', () => { updateDates(); refreshCart().catch(() => cartError(text.networkError)); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) { updateDates(); refreshCart().catch(() => cartError(text.networkError)); } });
  refreshCart().catch(() => cartError(text.networkError));
})();
